module.exports = __webpack_public_path__ + "static/media/drumstick-bite.26d6baf7.svg";